module.exports = __webpack_public_path__ + "img/galette_1200px.ff1ad2dc.png";